module.exports = __webpack_public_path__ + "static/img/500.7d8573ea.png";